/**
 * @author lifei
 * 功能： actions,
 *  1. options 参数暂不启用，需要重新规划
 */
import OSS from 'ali-oss'
import { aUser } from '@/apis'
import { isNull, omit } from 'lodash-es'
import { Cache } from '@/tools'
import { eventEmitter } from '@/tools'

type AccessData = {
  accessKeyId: string
  accessKeySecret: string
  bucket: string
  stsToken: string
  endtime: number
}
type OssInfoData = {
  public?: AccessData
  private?: AccessData
}

export class Oss<T extends TCommon.TStore.State, K extends TCommon.TStore.State> {
  constructor() {}
  /**
   * 功能：授权信息的授权有效时间
   */
  private expired = 3600 * 1000 * 24

  private OSSClient!: OSS

  /**
   * 功能：获取签名信息
   */
  private getOssAuthorization = async (mode: 'private' | 'public') => {
    // 官网示例
    // const client = new OSS({
    //   // yourRegion填写Bucket所在地域。以华东1（杭州）为例，Region填写为oss-cn-hangzhou。
    //   region: 'yourRegion',
    //   // 从STS服务获取的临时访问密钥（AccessKey ID和AccessKey Secret）。
    //   accessKeyId: 'yourAccessKeyId',
    //   accessKeySecret: 'yourAccessKeySecret',
    //   // 从STS服务获取的安全令牌（SecurityToken）。
    //   stsToken: 'yourSecurityToken',
    //   refreshSTSToken: async () => {
    //   // 向您搭建的STS服务获取临时访问凭证。
    //     const info = await fetch('your_sts_server');
    //     return {
    //       accessKeyId: info.accessKeyId,
    //       accessKeySecret: info.accessKeySecret,
    //       stsToken: info.stsToken
    //     }
    //   },
    //   // 刷新临时访问凭证的时间间隔，单位为毫秒。
    //   refreshSTSTokenInterval: 300000,
    //   // 填写Bucket名称。
    //   bucket: 'examplebucket'
    // });
    // const params = {
    //   stsToken: '',
    //   accessKeyId: '',
    //   accessKeySecret: '',
    // }
    // this.OSSClient = new OSS(params)
  }
  /**
   * 功能：上传文件
   */
  uploadFile = () => {
    return Promise.resolve()
  }

  /**
   * 功能：获取 OSS url 地址
   */
  getFileUrl = (): Promise<string> => {
    return Promise.resolve('')
  }
}
